<template>
  <!--      弹窗组件-->
  <el-dialog
      class="custom-dialog"
      center
      :title="dialogData.title"
      :visible.sync="dialogData.visible"
      :width="(dialogData.width || 500) + 'px'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      :show-close="!dialogData.hideClose"
  >
    <!--    内容-->
    <div class="dialog-content">
      <slot></slot>
    </div>
    <!--    footer-->
    <div slot="footer" class="dialog-footer">
      <template v-if="!dialogData.hideBtn">
        <!--      需要自定义footer时在父组件添加<template slot="customFooter">自定义内容</template>-->
        <slot name="customFooter">
          <!--      后备内容-->
          <el-button size="small" class="cancel-btn" @click="dialogData.visible = false">取消</el-button>
          <el-button size="small" type="primary" class="confirm-btn" @click="confirm">确定</el-button>
        </slot>
      </template>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "vueDialog",
  props: {dialogData: Object},
  methods: {
    confirm() {
      this.$emit("confirm");
    }
  }
}
</script>

<style scoped lang="scss">
.dialog-content {
  padding: 10px 0;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 12px;
  /deep/ {
    .el-button {
      min-width: 90px;
      border-radius: 8px;
      padding: 9px 20px;
      font-size: 14px;
      transition: all 0.2s ease;
    }
  }
}


</style>
